<template>
  <div id="contact" class="content md-layout md-gutter md-alignment-center-center">
    <div class="md-layout-item md-alignment-center-center">
      <h1>{{ $t("Contact") }}</h1>
      <p>{{ $t('contact me') }}</p>
      <p><b>Email:</b> <a href="mailto:fceschin3@gatech.edu">fceschin3@gatech.edu</a> | <a href="mailto:fjoceschin@inf.ufpr.br">fjoceschin@inf.ufpr.br</a></p>
      <p><b>Facebook:</b> <a href="https://www.facebook.com/fabricio.ceschin" target="_blank">fb.com/fabricio.ceschin</a></p>
      <p><b>Twitter:</b> <a href="https://www.twitter.com/fabriciojoc" target="_blank">@fabriciojoc</a></p>
      <p><b>LinkedIn:</b> <a href="http://br.linkedin.com/in/fabricioceschin" target="_blank">linkedin.com/in/fabricioceschin</a></p>
      <p><b>Scholar:</b> <a href="https://scholar.google.com/citations?user=73-lqdUAAAAJ&hl=en" target="_blank">Fabrício Ceschin</a></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  title: 'Fabrício Ceschin - Contact',
  props: {
    // msg: String,
    // num: Number
  },
  mounted() {
    this.$ga.page('/contact');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#contact {
  text-align:left;
}

#contact h1 {
  text-align:center;
}
</style>
